import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../rootReducer';
import { Features, isFeatureEnabled } from '../../featureToggles/features';

export enum ViewTypes {
  Account = 'accounts',
  Team = 'teams',
  User = 'users'
}
const initialActiveView = isFeatureEnabled(Features.PlgExternal) ? ViewTypes.Account : ViewTypes.User;

export type DashboardViewState = {
  activeView: ViewTypes;
}

export const initialState: DashboardViewState = {
  activeView: initialActiveView
};

const getDashboardViewState = (state:RootState): DashboardViewState => state.adminDashboard.view;
export const getActiveView = (state:RootState): ViewTypes => getDashboardViewState(state).activeView;

const dashboardViewSlice = createSlice({
  name: 'dashboardView',
  initialState,
  reducers: {
    setActiveView: (state: DashboardViewState, action: PayloadAction<ViewTypes>) => {
      state.activeView = action.payload;
    }
  }
});

export default dashboardViewSlice.reducer;

export const {
  setActiveView
} = dashboardViewSlice.actions;
export const caseReducers = dashboardViewSlice.caseReducers;
